import { Routes } from '@angular/router';
import { isPersistanceGuard, loginRouteGuard } from './_core/guards';
import { nebulaConst } from '@interfaces/nebulaConst';
import { applicationRoutes } from './application/application.routes';
import { administrationRoutes } from './administration/administration.routes';

export const routes: Routes = [
  // -- Loginseite
  {
    path: '',
    redirectTo: '/start',
    pathMatch: 'full'
  },
  {
    path: 'start',
    canActivate: [isPersistanceGuard()],
    data: { breadcrumbLabel: `${nebulaConst.appTitle}` },
    loadComponent: () => import('./_core/components/startpage/startpage.component').then(m => m.StartpageComponent)
  },

  // -- Navigationseinträge Anwendungsfunktionen
  {
    path: 'application',
    canActivate: [loginRouteGuard()],
    children: applicationRoutes,
    loadComponent: () => import('./application/application.component').then(m => m.ApplicationComponent)
  },

  // -- Navigationseinträge Adminbereich
  {
    path: 'administration',
    canActivate: [loginRouteGuard()],
    children: administrationRoutes,
    loadComponent: () => import('./administration/administration.component').then(m => m.AdministrationComponent)
  },

  // Präsentation – kein App-Shell (kein Header / Navigation)
  {
    path: 'presentation',
    loadComponent: () => import('./application/components/presentation-window/presentation-window.component').then(m => m.PresentationWindowComponent)
  },

  // unbekannte Routen führen zur PageNotFound-Seite
  {
    path: '**',
    loadComponent: () => import('@components/page-not-found/page-not-found.component').then(m => m.PageNotFoundComponent)
  }
];
